<template>
    <div class="remarks">

        <div class="top">
            <div class="select-tab" @click="activeIndex = 0" :class="{ active:activeIndex == 0}">文档</div>
            <div class="select-tab" @click="activeIndex = 1" :class="{ active:activeIndex == 1}">评论</div>
            <div class="select-tab" @click="activeIndex = 2" :class="{ active:activeIndex == 2}">日志</div>
        </div>

        <div class="bottom">
            <!--文档-->
            <div class="file"  v-show="activeIndex == 0">
                <z-scrollDiv class="file-list-wrap" :class="{all:!can_edit}" ref="file">
                    <!--下载列表  需求文档-->
                    <div v-show="require_files.length" class="top-text">需求文档</div>
                    <transition-group name="list" class="file-list" tag="div" ref="requireList">
                        <div class="file-item" v-for="item in require_files" :key="item.id">
                            <div>{{item.doc_name}}</div>
                            <div class="func">
                                <span class="download">
                                    <a @click="downloadFile(item.id)">下载</a>
                                </span>
                                <!-- <span v-if="key == 'start' && (taskDetails.start_status == '10' || '30')" @click="addDelDoc(item,index)" class="del">删除</span> -->
                            </div>
                            <div class="time">{{ item.updated_at }}</div>
                        </div>
                    </transition-group>

                    <!--下载列表  交付文档  -->
                    <div v-show="deliver_files.length" class="top-text">交付文档</div>
                    <transition-group name="list" class="file-list" tag="div" >
                        <div class="file-item" :key="item.id" v-for="item in deliver_files">
                            <div>{{item.doc_name}}</div>
                            <div class="func">
                                <span class="download">
                                    <a @click="downloadFile(item.id)">下载</a>
                                </span>
                                <!-- <span v-if="key == 'start' && (taskDetails.start_status == '10' || '30')" @click="addDelDoc(item,index)" class="del">删除</span> -->
                            </div>
                            <div class="time">{{ item.updated_at }}</div>
                        </div>
                    </transition-group>

                    <!--上传列表-->
                    <transition name="fade">
                        <div class="file-list"  style="min-height:55px" v-show="upload_doc.length">
                            <!-- <div v-if="task_id!='0' &&  (key!='start' || taskDetails.start_status!='10')" class="top-text">新添文档</div> -->
                            <div class="top-text">新添文档</div>
                            <transition-group tag="div" name="list">
                                <div class="file-item" :key="index" v-for="(item,index) in upload_doc">
                                    <div>{{item.name}}</div>
                                    <div class="func">
                                        <span @click="removeUpItem(index)" class="del">删除</span>
                                    </div>
                                </div>
                            </transition-group>

                            <div class="btn-list">
                                <span @click="quitUpload()">取消</span>
                                <span @click="confirmUpload()">
                                    <span v-if="docLoading" :class="{'el-icon-loading':docLoading}"></span>
                                    <span v-else>上传</span>
                                </span>
                            </div>
                        </div>
                    </transition>
                </z-scrollDiv>
                    

                <!--底部功能按钮-->
                <div class="btn-bottom-func" v-if="can_edit">
                    <!--上传附件-->
                    <div class="btn">
                        <input id="doc" type="file" multiple @change="addUploadFile($event)">
                        <div>
                            <img src="~src/assets/image/upload.svg">
                            <span>添加附件</span>
                        </div>
                    </div>
                    <!--文档模板下载-->
                    <div class="btn" @click="$emit('openDoc')">
                        <div>
                            <img src="~src/assets/image/download.svg">
                            <span>文档模板下载</span>
                        </div>
                    </div>
                </div>

            </div>

            <!--评论-->
            <div class="comment" v-show="activeIndex == 1">
                <z-scrollDiv class="all-comment" ref="all-comment" :style="{height:`calc(100% - ${commentBottomH}px)`}">
                    <div class="comment-list" :key="item.id" v-for="(item,index) in task_comment">
                        <div class="left">
                            <z-lazyImg class="userimg" :src='item.user_logo'></z-lazyImg>
                            <p>{{ item.real_name }}</p>
                        </div>
                        <div class="right">
                            <div class="comment-content">{{item.log_content}}</div>
                            <p class="action">
                                <span @click="delComment(index)" class="del" v-if="task_id=='0'">删除</span>
                                <span class="time">{{ item.created_at | commentTime }}</span>
                            </p>
                        </div>
                    </div>
                </z-scrollDiv>

                <div class="comment-input" v-if="can_edit" @mouseenter="activeHover=true" @mouseleave="activeHover=false">
                    <div class="comment-fun">
                        <div class="area-wrap">
                            <textarea class="pre" v-model="commentText"></textarea>
                            <textarea ref="comment-area" type="text" v-model="commentText" :class="['comment-text',{active:commentFlag}]" :style="{height:commentInputH + 'px'}" @input="checkHeight('commentInputH',$event)" @focus="focusComment()" @blur="blurComment()" @keydown.enter.prevent="subcomment" placeholder="添加评论"></textarea>
                        </div>
                        <div class="comment-btns" @click="focusComment()" :class="{active:commentFlag}">
                            <span class="btn" @click="clearInput">清除</span>
                            <span class="btn" @click="subcomment">
                                <span v-if="commentLoading" :class="{'el-icon-loading':commentLoading}"></span>
                                <span v-else>发送</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!--日志-->
            <z-scrollDiv class="log" v-show="activeIndex == 2">
                <div class="log-item" :key="item.id" v-for="item in task_log">
                    <div class="log-left overhide">
                        <span class="img"></span>
                        <span class="member" :title="item.real_name">{{ item.real_name }}</span>
                    </div>
                    <p class="log-right comment-content">
                        {{ item.log_content.split("：")[0] }}
                    </p>
                    <span class="time">{{ item.updated_at | justDate}}</span>
                </div>
            </z-scrollDiv>

        </div>
        
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import { scrollBottom } from "src/control/common.js"
    export default {
        props:["read","detailData"],
        data(){
            return {
                activeIndex: 0,  //tab切换判断
                require_files:[], //需求文档
                deliver_files:[], //交付文档
                upload_doc:[],   //想上传的文件
                docLoading: false,  //上传等待判断器

                activeHover: false,  //鼠标是否在激活区内
                commentFlag: false,  //评论输入框是否激活
                commentText: "",    //输入框的值
                commentLoading: false,  //评论发送等待
                commentInputH: 30,    //评论区textarea的高度
                task_comment: [],     //评论的内容数组
            }
        },

        computed:{
            ...mapState(["buInfo","taskId"]),
            task_id(){   //任务id
                let str = this.$route.params.task_id;
                return this.taskId != undefined? this.taskId : this.$crypto.decrypt(str);
            },
            can_edit(){  //只读判断
                let  data = this.detailData;
                let status = data.category_status;
                let process = data.process_status;

                let arr = [
                    status == 20 && process == 201 && data.sub_bu_id == this.buInfo.id,   //接收中
                ];
                return !(this.read || arr.some(val=>val) );
            },

            sub_commentStr() {   //保存时提交的评论数组
                return this.task_comment.map(item => {
                    return item.log_content;
                });
            },
            commentBottomH() {  //评论输入区的总高度
                if(!this.can_edit){
                    return 0;
                }
                return this.commentFlag ? this.commentInputH + 21 + 37 : this.commentInputH + 21;
            },
            task_log(){    //日志
                return this.detailData.task_log;
            },
            logText(){
                let log = this.detailData.task_log;
                return log?log.map(item=>{
                    return item.log_content.split("：")[0];
                }) : [];
            },
        },

        filters:{
            commentTime(str){  //任务remark 评论时间
                if(!str){
                    return "";
                }
                let time_arr = str.split(" ");
                return `${time_arr[0]} ${time_arr[1].substr(0, 5)}`
            },
        },

        mounted(){
            this.init();
        },

        watch:{
            detailData(){
                this.init();
            },
            activeIndex(val){
                if(val == 1){
                    setTimeout(()=>{
                        this.$refs["all-comment"].scrollBottom(300);
                    })
                }
            }
        },

        methods:{
            init(){
                this.require_files = this.detailData.task_requirement_doc || [];
                this.deliver_files = this.detailData.task_deliverable_doc || [];
                this.task_comment = this.detailData.task_comment || [];
                this.activeIndex = 0;
            },

            // ***文档
            addUploadFile(event){  //添加上传文件
                let input = event.target;
                for (let item of input.files) {
                    this.upload_doc.push(item);
                }
                console.log(this.$refs["file"]);
                this.$refs["file"].scrollBottom(200);
                input.value = '';
            },
            removeUpItem(index) {  //移除上传文档
                this.upload_doc.splice(index, 1);
            },
            quitUpload() {  //取消上传
                this.upload_doc = [];
            },
            confirmUpload:(()=> {  //确认上传
                let flag = false;  //判断器
                return function(){
                    if(flag){
                        return;
                    }
                    flag = true;

                    let list = this.upload_doc;
                    let all = 0;  //文件总大小
                    // 文件大小检测
                    for(let i = 0,len = list.length; i<len; i++){
                        let size = list[i].size/1024;
                        if(size > 10000){ //10M
                            this.errorTip(`单个文件大小不得超过10M`);
                            flag = false;
                            return;
                        }
                        all+= size;
                    };
                    if(all > 100000){  //100M
                        this.errorTip(`上传文件总大小不得超过100M`);
                        flag = false;
                        return;
                    }


                    // 开始上传
                    var myUpdated = new FormData();
                    list.forEach(function (item) {
                        myUpdated.append('task_requirement_docs[]', item);
                    });
                    this.docLoading = true;

                    let url = `api/clerk/task/doc/${this.task_id}`;
                    this.$http.post(url, myUpdated, {
                        transformRequest: [function (data) {
                            return data;
                        }]
                    }).then(res => {
                        if(res.status == 200){
                            if(this.buInfo.id == this.detailData.pub_bu_id){//需求文档
                                this.$refs["file"].scrollBottom(200,"0px");
                                res.res_data.forEach(item=>{
                                    this.require_files.unshift(item);
                                });
                            }else if(this.buInfo.id == this.detailData.sub_bu_id){ //交付文档
                                let distance = this.$refs["requireList"].$el.offsetHeight;
                                this.$refs["file"].scrollBottom(200,distance);
                                res.res_data.forEach(item=>{
                                    this.deliver_files.unshift(item);
                                });
                            }
                        }
                        this.upload_doc = [];
                        this.docLoading = false;
                        flag = false;
                    }).catch(err => {
                        this.errorTip("出错了");
                        this.docLoading = false;
                        flag = false;
                    });
                }

            })(),
            downloadFile(id){  //下载文件
                this.$http.get(`api/clerk/task_doc/${id}/download`);
            },


            //*****评论 
            delComment(index) {  //删除未发布评论
                this.task_comment.splice(index, 1);
            },
            focusComment() {  //获得焦点
                this.commentFlag = true;
            },
            blurComment() { //失去焦点
                if (!this.activeHover) {
                    this.commentFlag = false;
                } else {
                    this.$refs["comment-area"].focus();
                }
            },
            clearInput() {  //清空输入框
                this.commentText = "";
                this.commentInputH = 30;
            },
            subcomment() {  //提交任务评论
                if (this.commentText === "") {
                    return;
                }
                this.commentLoading = true;
                let url = `api/clerk/task/comment/${this.task_id}`;

                this.$http.post(url,{
                    log_content:this.commentText,
                }).then(res => {
                    this.task_comment.push(res.res_data);
                    this.$refs["all-comment"].scrollBottom(300);
                    this.commentLoading = false;
                    this.clearInput();
                }).catch(error => {
                    this.commentLoading = false;
                });
            },
            checkHeight(keyStr, e) {  // 任务描述文本域的高度处理
                e = e || window.event;
                let area = e.target;  //文本域
                let pre = area.previousElementSibling || area.nextElementSibling;  //兄弟节点

                let keys = keyStr.split(".");
                let result;
                let obj = this;

                for (var i = 0, len = keys.length; i < len - 1; i++) {
                    result = result ? result[keys[i]] : this[keys[0]];
                    if (i == len - 2) {
                        obj = result;
                    }
                }
                obj[keys[i]] = pre.scrollHeight;
            },



        }

    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    
    @top_h:40px;   //文档头部高度
    @bottom:50px;  //文档底部按钮高度
    @blue:#108ee9;

    .remarks{
        box-sizing: border-box;
        width: @detail_right;
        height:350px;
        border:1px solid @border-c;
        border-radius:2px;

        // tab 头
        .top{
            height: @top_h;
            box-sizing: border-box;
            // line-height: 40px;
            border-bottom: 1px solid @border-c;
            overflow: hidden;

            .select-tab{
                float: left;
                width: 33.33%;
                text-align: center;
                font-size: 12px;
                color:#808080;
                transition: 0.3s;

                height:calc(~"@{top_h} - 1px - 2px");
                line-height: calc(~"@{top_h} - 1px - 2px");
                border-bottom: 2px solid transparent;
                cursor: pointer;

                &.active{
                    border-bottom: 2px solid #01b6ad;
                    color:#333;
                }

            }
        }

        // tab wrap
        .bottom{
            height:calc(~"100% - @{top_h}");
        }

        //******* 文档
        .file{
            padding: 0 10px 10px;
            height: 100%;
            box-sizing: border-box;
            overflow: hidden;
            position: relative;

            // 文件列表区
            .file-list-wrap{
                height:calc(~"100% - @{bottom}");
                &.all{
                    height:100%;
                }
            }

            // 底部功能按钮
            .btn-bottom-func{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: @bottom;
                border-top:1px solid @border-c;
                box-sizing: border-box;
                .btn{
                    position: relative;
                    cursor: pointer;
                    width: 50%;
                    height: 100%;
                    float: left;
                    &:first-child{
                        &:after{
                            content:"";
                            position: absolute;
                            height: 80%;
                            display: block;
                            width:0;
                            border-right: 1px solid @border-c;
                            left: 100%;
                            top:10%;
                            z-index:3;
                        }
                    }

                    &:hover{
                        background:#fafafa;
                        >div span{
                            color:@main-c;
                        }
                    }

                    >div{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        line-height: 20px;
                        text-align: center;
                        overflow: hidden;
                        width: 100%;
                    
                        span{
                            margin-left: 5px;
                            font-size:12px;
                            // color:#4a90e2; 
                            color:#808080;
                            transition:0.3s;
                        }
                        img,span{
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                }

                // 上传附件
                input{
                    position: absolute;
                    z-index: 2;
                    height: 100%;
                    width: 100%;
                    top: 0;
                    left: 0;
                    opacity: 0;
                    cursor: pointer;
                }
            }
        }

        // 文件列表区
        .file-list-wrap{
            overflow-x: hidden;
            .top-text{
                font-size:12px;
                color: #333; 
                margin-top: 10px;
            }
            .fileup{
                width: 26px;
                height: 10px;
                display: inline-block;
                margin-left: 0;
                background: url("~src/assets/image/fileup.png") no-repeat;
                cursor: pointer;
            }
            .down-tem{
                font-size:12px;
                color:#4a90e2;
                text-align:left;
                padding-left: 26px;
                padding-top: 10px;
                cursor: pointer;
            }
            // 下载列表
            .file-list{
                font-size:14px;
                color:#808080;
                text-align:left;
                position: relative;
                overflow-x: hidden;
                // min-height: 55px;
                .top-text{
                    font-size:12px;
                    color: #333; 
                }

                .btn-list{
                    text-align: right;
                    margin-top: 15px;
                    >span{
                        cursor: pointer;
                        display: inline-block;
                        box-sizing: border-box;
                        width: 48px;
                        height: 22px;
                        line-height: 22px;
                        border-radius: 2px;
                        font-size: 12px;
                        text-align: center;
                        transition: 0.3s;
                        &:nth-of-type(1){
                            background:#fff;
                            color: #666;
                            border: 1px solid #d9d9d9;
                            margin-right: 10px;
                            line-height: 22px - 2px;
                            &:hover{
                                color: #108ee9;
                                border-color: #108ee9;
                                background:#fafafa;
                            }
                        }

                        &:nth-of-type(2){
                            background:#108ee9;
                            color: #fff;
                            span{
                                color: #fff;
                            }
                            &:hover{
                                // background: #29a0f5;
                                opacity:0.7;
                            }
                        }

                    }
                }

                // 单文件
                .file-item{
                    @item-h:46px;   //项目高度
                    @padd:10px;   //左右间隙

                    padding: @padd;
                    margin-top: 9px;
                    position: relative;
                    box-sizing: border-box;
                    font-size: 12px;
                    color: #333;
                    min-height: @item-h;
                    width: 100%;
                    // line-height: 40px;
                    background:#fafafa;
                    border:1px solid #e3e3e3;
                    border-radius:4px;
                    // &:first-child{
                    //   margin-top: 0;
                    // }

                    >div:first-child{
                        max-width: calc(~"100% - 70px");
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .func{
                        position: absolute;
                        right: @padd + 5px;
                        top: 50%;
                        transform: translateY(-50%);
                        overflow: hidden;
                        zoom: 1;
                        .del,.download{
                            cursor: pointer;
                            display: block;
                            float: left;
                            margin-left: 10px;
                        }

                        .del{
                            color: #ff6b6b;
                        }
                        .download{
                            a{
                                color: #108ee9;
                            }
                        }
                    }

                    .time{
                        color:#ccc;
                        // font-style:italic;
                        font-style:oblique;
                        // line-height: 10px;
                        font-size: 12px;
                        // padding-top: 5px;
                    }
                }

                &:nth-of-type(2){
                    margin-top: 9px;
                }
                
            }
        }   


        // *******评论
        .comment{
            height: 100%;
            position:relative;
            .all-comment{
                // height:340px;
                // overflow-y: auto;
                overflow: hidden;
                transition: 0.3s;
                // 评论条目
                .comment-list{
                    font-size: 12px;
                    border-bottom: 1px solid #d8d8d8;
                    height: auto;
                    margin-bottom: 20px;
                    padding-top:16px;
                    padding-bottom:8px;
                    margin: 0 20px;
                    overflow:hidden;
                    &:last-child{
                        border-bottom: 0;
                    }
                    // width:100%;
                    
                    .left{
                        width: 50px;
                        text-align: center;
                        float: left;
                        .userimg{
                            width:24px;
                            height:24px;
                            border-radius: 50%;
                            display: block;
                            margin: 0 auto;
                            margin-bottom: 3px;
                        }
                        p{
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    .right{
                        width: calc(~"100% - 50px");
                        box-sizing: border-box;
                        padding-left: 10px;
                        float: left;
                        margin:0;
                        color:#808080;
                        letter-spacing:0.62px;
                        line-height:16px;
                        text-align:left;
                    }

                    .comment-content{
                        word-wrap: break-word;
                    }

                    .action{
                        margin-top: 10px;
                        text-align: right;
                        .del{
                            color: #ff6b6b;
                            margin-left: 10px;
                            cursor: pointer;
                        }
                        .time{
                            color: #7f7f7f;
                        }
                    }

                }
            }
            .comment-input{
                position:absolute;
                width: 100%;
                min-height: 48px;
                bottom: 0;
                left: 0;
                background: #fbfbfb;
                border-top: 1px solid #d9d9d9;
                box-sizing: border-box;
                padding: 10px;
                transition: 0.2s;
                .comment-fun{
                    background:#ffffff;
                    border:1px solid #d9d9d9;
                    border-radius:2px;
                    overflow: hidden;
                    // height: 100%;
                    .area-wrap{
                        box-sizing: border-box;
                        position: relative;
                        .pre{
                            position: absolute;
                            left: 0;
                            top: 0;
                            opacity: 0;
                            z-index: -1;
                        }
                        // 输入框
                        .pre,.comment-text{
                            display: block;
                            box-sizing: border-box;
                            height: 30px;
                            width: 100%;
                            padding: 8.5px 0;
                            padding-left: 10px;
                            font-size: 12px;
                            color: #808080;
                            resize: none;
                            transition: 0.3s;
                            overflow: hidden;
                            &.active{
                            // height: 38px;
                            // line-height: 38px;
                            }
                        }
                    }

                    // 按钮
                    .comment-btns{
                        font-size: 0;
                        text-align: right;
                        border-top: 1px solid #d9d9d9;
                        height: 0;
                        opacity: 0;
                        transition: 0.3s;
                        padding: 0 8px;
                        box-sizing: border-box;
                        
                        &.active{
                            padding: 6px 8px;
                            height: auto;
                            opacity: 1;
                        }
                        .btn{
                            display: inline-block;
                            font-size: 12px;
                            text-align: center;
                            cursor: pointer;
                            height: 24px;
                            line-height: 24px;
                            transition: 0.3s;
                            &:nth-of-type(1){
                                color: @blue;
                                margin-right: 20px;
                            }
                            &:nth-of-type(2){
                                width: 64px;
                                // border: 1px solid #d9d9d9;
                                border-radius: 3px;
                                background: @blue;
                                color: #fff;
                                span{
                                    color: #fff;
                                }
                                &:hover{
                                    opacity: 0.8;
                                }
                            }
                        }
                    }
                    
                }

            }
        }

                  // 日志
        .log{
            height:100%;
            // height: 390px;
            // overflow-y: auto;
            padding: 15px 10px;
            box-sizing: border-box;
            
            .log-item{
              overflow:hidden;
              font-size: 12px;
              position: relative;
              margin-bottom: 12px;
              .log-left{
                float:left;
                width:92px;
              }
              .log-right{
                float:left;
                width:226px;
                margin-left: 10px;
              }
            }
            // p{
            //   line-height: 32px;
            // }
            .img{
              width:16px;
              height:9px;
              display: inline-block;
              background: url("~src/assets/image/log_icon.png") no-repeat;
              cursor: pointer;
            }
            .member{
              margin-left: 10px;
              color:#808080;
            }
            .action{
              color:#808080;
            }
            .time{
              font-size:12px;
              color:#7f7f7f;
              letter-spacing:0.62px;
              display: inline-block;
              float:right;
              line-height:22px;
              position: absolute;
              right: 5px;
              top: 50%;
              transform:translateY(-50%);
            }

        }

    }

    // 下载列表
    .list-enter-active, .list-leave-active {
        transition: all 0.8s;
    }
    .list-enter, .list-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
    .list-move{
        transition: 0.8s;
    }
    .list-leave-active {
        position: absolute !important;
    }

</style>






// WEBPACK FOOTER //
// remark.vue?832685a2